// @ts-nocheck
import $ from "jquery";

var $warenkorb = $("div.warenkorb");
const $weiterButton = $("button[type='submit'][name='weiter']");

$(window).on("load", () => {
	var radio = $("input[type='radio'][name='zahlungsart']:checked");
	if (radio.length) {
		toggleZahlungsartenSichtbarkeit(radio);
	}
});

$warenkorb.find(".cart-client-selection input:radio")
	.on("change", setAgb);

function setAgb(e) {
	var radio = $(e.originalEvent.srcElement);
	var agbTyp = $(radio).data("kundenart");
	showAgb(agbTyp);
}

function showAgb(agbTyp) {
	var agbGeschaeftlich = $warenkorb.find(".agb_geschaeftlich");
	var agbPrivat = $warenkorb.find(".agb_privat");

	switch (agbTyp) {
		case 1:
			agbGeschaeftlich.show();
			agbPrivat.hide();
			break;
		case 2:
			agbGeschaeftlich.hide();
			agbPrivat.show();
			break;
		default:
			agbGeschaeftlich.hide();
			agbPrivat.hide();
	}
}

var $rechnungsadresse = $warenkorb.find("#rechnungsadresse");
var warenkorbAdresse = {
	Kundenart: $warenkorb.find("#Kundenart"),
	Anrede: $warenkorb.find("#Anrede"),
	Vorname: $warenkorb.find("#Vorname"),
	Nachname: $warenkorb.find("#Nachname"),
	Kundenname1: $warenkorb.find("#Kundenname1"),
	Kundenname2: $warenkorb.find("#Kundenname2"),
	Abteilung: $warenkorb.find("#Abteilung"),
	Ortsteil: $warenkorb.find("#Ortsteil"),
	Strasse: $warenkorb.find("#Strasse"),
	PLZStrasse: $warenkorb.find("#PLZStrasse"),
	Ort: $warenkorb.find("#Ort")
};

$("#LieferadresseGleichRechnungsadresse").on("change", function() {
	var lieferadressen = $("#lieferadressen");

	if ($(this).prop("checked")) {
		lieferadressen.hide();
	}
	else {
		lieferadressen.show();
	}
});

//Warenkorb Verpackungseinheiten:
//Für Artikel mit Verpackungseinheiten werden select"s statt textboxen geredert
//beim Ändern dieser soll auch gleich der Warenkorb neu berechnet werden
$(".cart-list .cart-list__amount select").on("change", function() {
	$(this).closest("form").trigger("submit");
});

$warenkorb.find("#Kundenart,#Anrede,#Vorname,#Nachname,#Kundenname1,#Kundenname2,#Abteilung,#Ortsteil,#Strasse,#PLZStrasse,#Ort").on("change", setRechnungsadresse);
$warenkorb.find("#Vorname,#Nachname,#Kundenname1,#Kundenname2,#Abteilung,#Ortsteil,#Strasse,#PLZStrasse,#Ort").on("keydown", function() {
	clearTimeout($.data(this, "warenkorb-rechnungsadresse-timer"));
	var wait = setTimeout(setRechnungsadresse, 100);
	$(this).data("warenkorb-rechnungsadresse-timer", wait);
});

function setRechnungsadresse() {
	$rechnungsadresse.html(getAdresseFormatiert());
}

//Achtung: Funktion ist doppelt vorhanden
//Ganter.Web.Mvc.Entities.MeinGanter.Adresse.GetAdresseFormatiert
function getAdresseFormatiert() {
	var adresseFormatiert = "";
	var ortsteilFormatiert = "";
	var newLine = "<br />";

	//Kundenname1 und Kundenname2 nur für Firmenadressen
	if (warenkorbAdresse.Kundenart.val() === "0" || warenkorbAdresse.Kundenart.val() === "1") {
		adresseFormatiert = warenkorbAdresse.Kundenname1.val() + newLine;
		if (warenkorbAdresse.Kundenname2.val() !== "") {
			adresseFormatiert = adresseFormatiert + warenkorbAdresse.Kundenname2.val() + newLine;
		}

		//Abteilung
		if (warenkorbAdresse.Abteilung.val() !== "") {
			adresseFormatiert = adresseFormatiert + warenkorbAdresse.Abteilung.val() + newLine;
		}
	}

	//Anrede
	adresseFormatiert = adresseFormatiert + warenkorbAdresse.Anrede.find(":selected").text();

	//Ortsteil
	if (warenkorbAdresse.Ortsteil.val() !== "") {
		ortsteilFormatiert = warenkorbAdresse.Ortsteil.val() + newLine;
	}

	adresseFormatiert = adresseFormatiert + " " + warenkorbAdresse.Vorname.val() + " " + warenkorbAdresse.Nachname.val() + newLine +
		ortsteilFormatiert +
		warenkorbAdresse.Strasse.val() + newLine +
		warenkorbAdresse.PLZStrasse.val() + " " + warenkorbAdresse.Ort.val();

	return adresseFormatiert;
}

// Toggeln der Sichbarkeit des Crefopay Iframes und des weiter Buttons für Rechnung
$("input[type='radio'][name='zahlungsart']").on("click", (e) => {
	toggleZahlungsartenSichtbarkeit(e.currentTarget);
});

function toggleZahlungsartenSichtbarkeit(radio) {
	if ($(radio).attr("id") == "zahlungsart-rechnung") {
		$("#weiter").toggle(true);
		$("#crefopay-zahlungsarten").toggle(false);
	}

	if ($(radio).attr("id") == "weitere-zahlungsarten") {
		$("#weiter").toggle(false);
		$("#crefopay-zahlungsarten").toggle(true);
	}
}

$("#warenkorb-import-link").on("click", function(e) {
	e.preventDefault();
	$("#warenkorb-import-file:hidden").trigger("click");
});

$("#warenkorb-import-file").on("change", function(e) {
	$("#warenkorb-import-form").trigger("submit");
});

$weiterButton.on("click", (e) => {
	var $input = $(e.currentTarget);
	if ($input.data("crefopay-payment-continue") == "True") {
		setTimeout(function() { disableWeiterButton($input); }, 0);
	}
});

function disableWeiterButton($input) {
	$input.prop("disabled", true);
	$input.removeClass("button--green");
	$input.addClass("button--disabled button--waiting-animation");
}

// Inocon AGB checkbox
$("input[type='checkbox'][name='agb']").on("change", (e) => {
	var agbChecked = $(e.currentTarget).prop("checked");
	$("#agb-error").toggle(!agbChecked);
	$weiterButton.toggleClass("btn--disabled", !agbChecked);
	$weiterButton.val(agbChecked ? "weiter" : null);
	$weiterButton.prop("disabled", !agbChecked);
});
